import { render, staticRenderFns } from "./ProjMargin.vue?vue&type=template&id=208b2e81"
import script from "./ProjMargin.vue?vue&type=script&lang=js"
export * from "./ProjMargin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports